<template>
	<v-menu
		v-model="isActiveMenu"
		:close-on-content-click="false"
	>
		<template #activator="{ props: settingProps }">
			<ao-icon-btn
				v-bind="settingProps"
				iconName="settings"
				variant="text"
				size="small"
			/>
		</template>
		<v-card>
			<v-list>
				<v-list-item
					v-bind="startDayMenuProps"
					height="30"
					max-height="30"
					min-height="30"
					:value="'item.title'"
					class="ao-p3-regular"
					@click="onClickStartDayButton"
				>
					{{ $t('Setting the start time of work') }}
				</v-list-item>
			</v-list>
		</v-card>
	</v-menu>
</template>

<script setup>
import { ref } from 'vue'

const emit = defineEmits({
	openStartDayDialog: null,
})

const onClickStartDayButton = () => {
	isActiveMenu.value = false
	emit('openStartDayDialog')
}

const isActiveMenu = ref(false)
</script>
